<template lang='pug' src='./custom-home-location.pug'></template>

<script>
export default {
  computed: {
    props () {
      return this.$store.state.pages['home']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/custom-home-location/custom-home-location.vue